import { SyntheticEvent, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router'

import { SetupWorkspaceRoutes } from 'app/application/types'
import { useUser } from 'app/user/application'

import { Button, Headline, Input } from 'components'

import accessStyles from '../AccessPage/AccessPage.module.scss'
import styles from './ResetPassword.module.scss'

const ResetPassword = () => {
  const navigate = useNavigate()
  const { t } = useTranslation('user')

  const { triggerPasswordReset } = useUser()

  const [email, setEmail] = useState('')
  const [error, setError] = useState('')

  const handlePasswordReset = (e: SyntheticEvent) => {
    e.preventDefault()

    void triggerPasswordReset(email).then((result) => {
      if (result.ok) {
        void navigate(SetupWorkspaceRoutes.CheckInbox, {
          state: { email },
        })
      } else {
        setError(result.val.message)
      }
    })
  }

  return (
    <div className={accessStyles.access}>
      <div className={styles.resetPassword}>
        <div>
          <Headline>{t('resetPassword.title')}</Headline>
          <div className={styles.description}>{t('resetPassword.description')}</div>
        </div>
        <form onSubmit={handlePasswordReset}>
          <Input
            autoComplete="username"
            autoFocus
            error={error}
            label={t('resetPassword.email')}
            onChange={setEmail}
            placeholder={t('resetPassword.placeholder')}
            value={email}
          />
          <Button disabled={!email} type="submit">
            {t('resetPassword.sendResetLink')}
          </Button>
        </form>
      </div>
    </div>
  )
}

export default ResetPassword
